import React, { memo } from 'react';

import { useStylesForContentHeader } from './styles';

interface IContentHeaderProps {
  title: string;
  subtitle?: string;
  styleClass?: string;
}

const ContentHeader = ({ title, subtitle, styleClass }: IContentHeaderProps) => {
  const classes = useStylesForContentHeader();
  return (
    <div className={`${classes.parent} ${styleClass || ''}`}>
      <p className={classes.title}>{title}</p>
      {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
    </div>
  );
};

export default memo(ContentHeader);
